/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Equipment } from 'src/app/_model/equipments';

@Injectable()
export abstract class EquipmentsDaoService implements Resetable {
  public abstract saveEquipments(equipments: Equipment[]): Promise<void>;
  public abstract getEquipments(): Promise<Equipment[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
